import React, {useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
// import { useHistory } from 'react-router-dom'
// Actions
import { Base_API } from '../../_actions/matcher'
import { NhealthAction } from '../../_actions/action.api'
// Styles
import './cfodmcps.style.css'
// Images
import CouponImage from '../../assets/images/rewards/reward-detail.png'
import { DecryptedOBJ, EncryptedOBJ, EncryptedText } from '../../utils/Encryption'

function CFOD_MyCoupons(props) {
    const { ref, cameFrom } = useParams();

    const [myCoupons, setMyCoupons] = useState(
        [
            {
                id: 1,
                name: 'ABC ลด 10%',
                exp_date: '12/06/2564'
            },
            {
                id: 2,
                name: 'บริการฆ่าเชื้อ แลกรับส่วนลด 100 บาท',
                exp_date: '12/06/2564'
            },
            {
                id: 3,
                name: 'บริการฆ่าเชื้อ แลกรับส่วนลด 100 บาท',
                exp_date: '12/06/2564'
            }
        ]
    );
    const [loading, setLoading] = useState(true);
    const [coupons, setCoupons] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [campaignData, setCampaignData] = useState(null);
    const [memberData, setMemberData] = useState(null);
    const [memberCode, setMemberCode] = useState(null);
    const [lineProfileData, setLineProfileData] = useState(null);
    const [btnLoading, setBtnLoading] = useState(false);


    useEffect(() => {
        dataInit();
    }, [])

    const dataInit = async() => {
        let campaignData = await campaignInit();
        let getMemberData = await checkUserInit();
        await couponsInit(campaignData, getMemberData);
        handlerLoader('inactive');
    }

    const campaignInit = () => {
        return new Promise(async resolve => {
            if(cameFrom === 'packages')
            {
                NhealthAction.GetCampaign(ref).then(data => {
                    // set date end
                    let p1 = String(data.appendDate).split('('); 
                    p1 = String(p1[1]).split(')');
                    p1 = Number(p1[0]);
                    localStorage.setItem('end-campaign', EncryptedText(p1));
                    setCampaignData(data.campaign);
                    resolve(data.campaign);
                })
            }else
            {
                NhealthAction.GetCampaignProductsOnline(ref).then(data => {
                    // set date end
                    let p1 = String(data.appendDate).split('('); 
                    p1 = String(p1[1]).split(')');
                    p1 = Number(p1[0]);
                    localStorage.setItem('end-campaign', EncryptedText(p1));
                    setCampaignData(data.campaign); 
                    resolve(data.campaign);
                })
            }
        })
    }

    const checkUserInit = () => {
        return new Promise(async resolve => {
            let line_profile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(line_profile !== null)
            {
                setLineProfileData(line_profile);

                NhealthAction.GetMember(line_profile.user_id)
                .then(res => {
                    // console.log('Get Member: ', res);
                    if(res.isSuccess === true)
                    {
                        setMemberData(res.member);
                        setMemberCode(res.member.membercode);
                        resolve(res.member.membercode);
                    }else
                    {
                        setMemberCode(line_profile.user_id);
                        resolve(line_profile.user_id);
                        // backToMainMenu();
                    }
                })
            }else
            {
                backToMainMenu();
            }
        })
    }

    const backToMainMenu = () => {
        if(cameFrom === 'packages')
        {
            window.location.href = `${Base_API.pathWeb}/n-health/packages/${ref}`;
        }else
        {
            window.location.href = `${Base_API.pathWeb}/n-health/nh-services/${ref}`;
        }
    }

    const handlerLoader = status => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const couponsInit = (campaignData, membercode) => {
        return new Promise(async resolve => {
            // console.log('Campaign Data: ', campaignData);
            // console.log('Member Data: ', memberData);

            // NhealthAction.GetCoupons(4, '', '230113000001') // test
            NhealthAction.GetCoupons(campaignData.id, '', membercode)
            .then(res => {
                // console.log('Coupons: ', res);
                setCoupons(res.coupon); 
                resolve();
            })
        })
    }

    const handleChange = e => {
        let value = e.target.value;

        setSearchText(value); 
    }

    const onSearch = async() => {
        NhealthAction.GetCoupons(campaignData.id, searchText, memberCode)
        .then(res => {
            setSearchText('');
            setCoupons(res.coupon); 

            handleButtonLoading();
        })
    }

    const handleButtonLoading = () => { // Protect spamming
        setBtnLoading(true);
        setTimeout(() => {
            setBtnLoading(false);
        },1000)
    }

    // handle selected coupon
    const handleSelectedCoupon = (data) => {
        localStorage.setItem('couponselected', EncryptedOBJ(data));
        window.location.href = cameFrom === 'packages' ? `${Base_API.pathWeb}/n-health/confirm-order/${ref}` : `${Base_API.pathWeb}/n-health/confirm-order-nhservices/${ref}`;
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="cfodmcps-container">
                {/* headtext */}
                <h1 className="header-text">
                    ใช้คูปองส่วนลด
                </h1>
    
                {/* Add Discount Coupon */}
                <div className="add-dccp">
                    <input 
                        type="text" 
                        placeholder="เพิ่มโค้ดส่วนลด" 
                        onChange={handleChange}
                        value={searchText}
                    />
                    <button
                        onClick={btnLoading ? null : onSearch}
                    >
                        {
                            btnLoading 
                            ?  
                            <div className="btn-loader"></div>
                            : 
                            'ค้นหา'
                        }
                    </button>
                </div>
    
                {/* Card (my coupons) */}
                <div className="card">
                    {coupons.length === 0 && 
                        <p className="notfound">ไม่พบคูปอง</p>
                    }

                    {coupons.length > 0 && coupons.map((item, i) => 
                        <div className="item" key={i}>
                            {/* left */}
                            <div 
                                className="left"
                                style={{backgroundImage: `url(${String(item.Couponcover).replace('~', '')})`}}
                            >
                            </div>
                            {/* right */}
                            <div className="right">
                                <div className="top">
                                    <div className="name t-bold"><p>{item.title}</p></div>
                                    <div className="desc t-normal">{item.description}</div>
                                </div>
                                <div className="under">
                                    <div className="exp-date t-normal">ใช้ได้ถึง {item.endDate}</div>
                                    <button
                                        onClick={() => handleSelectedCoupon(item)}
                                    >
                                        ใช้คูปอง
                                    </button>
                                </div> 
                            </div>
                        </div> 
                    )}

                    {/* For Dev  */}
                    {/* {myCoupons !== null &&
                        myCoupons.map((item, i) => 
                            <div className="item" key={i}>
                                <div 
                                    className="left"
                                    style={{backgroundImage: `url(${CouponImage})`}}
                                >
                                </div>
                                
                                <div className="mid">
                                    <div className="name t-bold">{item.name}</div>
                                    <div className="exp-date t-normal">ใช้ได้ถึง {item.exp_date}</div>
                                </div>

                                <div className="right">
                                    <button
                                        onClick={handleSelectedCoupon}
                                    >
                                        ใช้คูปอง
                                    </button>
                                </div>
                            </div> 
                        ) 
                    } */}
                </div>
            </div>
        )
    }
}

export default CFOD_MyCoupons